import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IDynamicFormValue } from 'src/lib';
import { getPlannerToggles } from '../../planner_v2/store/planner-slice-async-thunks';
import { IAsIsToBeStateV2 } from '../types/as-is-to-be-state.model';
import {
  getLocalFiltersData,
  getGridDataForAsAndToBeV2
} from './simulator-summary-slice-async-thunks';

const initialState: IAsIsToBeStateV2 = {
  fetchingLocalFiltersData: false,
  localFilterFormFields: [],
  localFilterInitialValues: {},
  localFilterValue: {},
  toBeGridMetrics: [],
  fetchingGridData: false,
  asIs: {
    column_headers: [],
    grid_data: [],
    row_headers: []
  },
  toBe: {
    column_headers: [],
    grid_data: [],
    row_headers: [],
    'gradient-metric-metadata': []
  },
  currentMetricToggle: null
};

const asIsToBeSliceV2 = createSlice({
  name: 'as-is-to-be-slice-v2',
  initialState,
  reducers: {
    resetGridMetrics(state) {
      state.localFilterInitialValues =
        state.localFilterFormFields.reduce<IDynamicFormValue>(
          (prev, curr) => ({ ...prev, [curr.name]: curr.default_value }),
          {}
        );
    },
    setLocalFilterValueInSummary(
      state,
      action: PayloadAction<IDynamicFormValue>
    ) {
      state.localFilterValue = action.payload;
    }
  },
  extraReducers: (builder) =>
    builder
      .addCase(getLocalFiltersData.pending, (state) => {
        state.fetchingLocalFiltersData = true;
      })
      .addCase(getLocalFiltersData.fulfilled, (state, action) => {
        state.fetchingLocalFiltersData = false;
        const { fields, values } = action.payload;
        state.localFilterFormFields = fields;
        state.localFilterInitialValues = values;
        state.localFilterValue = values;
      })
      .addCase(getLocalFiltersData.rejected, (state) => {
        state.fetchingLocalFiltersData = false;
      })
      .addCase(getGridDataForAsAndToBeV2.pending, (state) => {
        state.currentMetricToggle = null;
        state.fetchingGridData = true;
        state.asIs = {
          column_headers: [],
          grid_data: [],
          row_headers: []
        };
        state.toBe = {
          column_headers: [],
          grid_data: [],
          row_headers: []
        };
      })
      .addCase(getGridDataForAsAndToBeV2.rejected, (state) => {
        state.fetchingGridData = false;
        state.asIs = {
          column_headers: [],
          grid_data: [],
          row_headers: []
        };
        state.toBe = {
          column_headers: [],
          grid_data: [],
          row_headers: []
        };
      })
      .addCase(getGridDataForAsAndToBeV2.fulfilled, (state, action) => {
        state.fetchingGridData = false;
        const { colorGradient, asIs, toBe } = action.payload;
        state.toBeGridMetrics = colorGradient;
        [state.currentMetricToggle] = colorGradient;
        state.asIs = asIs;
        state.toBe = toBe;
      })
});

export const { resetGridMetrics, setLocalFilterValueInSummary } =
  asIsToBeSliceV2.actions;

export default asIsToBeSliceV2;
